import { ref as r, computed as n } from "vue";
function i(l, e, u) {
  let o = r(u?.value), v = n(() => l.value !== void 0);
  return [n(() => v.value ? l.value : o.value), function(a) {
    return v.value || (o.value = a), e?.(a);
  }];
}
export {
  i as useControllable
};
